// 매수 이력 API (tb_buy_history)
import axiosInstance from './axiosInstance';

// 매수 목록 조회 (필터: account_name, ticker, is_sold)
export const fetchBuyList = async (params = {}) => {
  const response = await axiosInstance.get('/buy', { params });
  return response.data.data;
};

// 차수 자동배정 - 계좌+종목에서 다음 차수 번호 조회
export const fetchNextTurnNo = async (account_name, ticker) => {
  const response = await axiosInstance.get('/buy/next-turn-no', {
    params: { account_name, ticker },
  });
  return response.data.turn_no;
};

// 매수 등록
export const createBuy = async (payload) => {
  const response = await axiosInstance.post('/buy', payload);
  return response.data;
};

// 매수 수정
export const updateBuy = async (id, payload) => {
  const response = await axiosInstance.put(`/buy/${id}`, payload);
  return response.data;
};

// 매수 삭제
export const deleteBuy = async (id) => {
  const response = await axiosInstance.delete(`/buy/${id}`);
  return response.data;
};
